import { render, staticRenderFns } from "./witholdings.vue?vue&type=template&id=042dbe16&scoped=true"
import script from "./witholdings.vue?vue&type=script&lang=js"
export * from "./witholdings.vue?vue&type=script&lang=js"
import style0 from "./witholdings.vue?vue&type=style&index=0&id=042dbe16&prod&lang=css"
import style1 from "./witholdings.vue?vue&type=style&index=1&id=042dbe16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042dbe16",
  null
  
)

export default component.exports